import _ from "lodash";
import ElementConstants from './ElementConstants';

export function elements(state = {}, action) {
    const newState = {
        ...state
    };

    switch (action.type) {
        case ElementConstants.ELEMENT_RECEIVED: {
            const element = action.payload;

            newState[element.id] = {
                id: element.id.toString(),
                slide_id: element.slide_id.toString(),
                type: element.element_type,
                x: parseInt(element.x),
                y: parseInt(element.y),
                width: parseInt(element.width),
                height: parseInt(element.height),
                position: parseInt(element.position),
                data: JSON.parse(element.data),
            };

            return newState;
        }
        case ElementConstants.ELEMENT_CHANGING: {
            const {id, changes} = action.payload;
            const {x, y, width, height, data} = changes;

            newState[id] = {
                ...newState[id]
            };

            if (typeof x !== 'undefined') {
                newState[id].x = parseInt(x) || 0;
            }

            if (typeof y !== 'undefined') {
                newState[id].y = parseInt(y) || 0;
            }

            if (typeof width !== 'undefined') {
                newState[id].width = parseInt(width);
            }

            if (typeof height !== 'undefined') {
                newState[id].height = parseInt(height);
            }

            if (data) {
                newState[id].data = {
                    ...newState[id].data,
                    ...data
                };
            }

            return newState;
        }
        case ElementConstants.ELEMENT_REMOVED: {
            return _.pickBy(state, element => element.id !== action.payload.id);
        }
        case ElementConstants.ELEMENT_BROUGHT_FORWARD: {
            const {id} = action.payload;

            const element = newState[id];
            let elementsForStory = _.pickBy(state, element => element.slide_id === newState[id].slide_id);

            elementsForStory = move(elementsForStory, id, element.position + 1);

            return {
                ...newState,
                ...elementsForStory
            }
        }
        case ElementConstants.ELEMENT_SENT_BACKWARD: {
            const {id} = action.payload;

            const element = newState[id];
            let elementsForStory = _.pickBy(state, element => element.slide_id === newState[id].slide_id);

            elementsForStory = move(elementsForStory, id, element.position - 1);

            return {
                ...newState,
                ...elementsForStory
            }
        }
        case ElementConstants.ELEMENT_BROUGHT_TO_FRONT: {
            const {id} = action.payload;

            let elementsForStory = _.pickBy(state, element => element.slide_id === newState[id].slide_id);

            elementsForStory = move(elementsForStory, id, Object.keys(elementsForStory).length);

            return {
                ...newState,
                ...elementsForStory
            }
        }
        case ElementConstants.ELEMENT_SENT_TO_BACK: {
            const {id} = action.payload;

            let elementsForStory = _.pickBy(state, element => element.slide_id === newState[id].slide_id);

            elementsForStory = move(elementsForStory, id, 1);

            return {
                ...newState,
                ...elementsForStory
            }
        }
        default: {
            return state;
        }
    }
}

function move(items, id, position)
{
    const itemCount = Object.keys(items).length;

    if (itemCount === 1) {
        items[id].position = 1;
        return items;
    }

    if (position > itemCount) {
        position = itemCount;
    }

    if (position < 1) {
        position = 1;
    }

    const otherItemsSorted = _.sortBy(
        _.pickBy(items, item => item.id !== id),
        ['position']
    );

    var otherItems = {};

    _.each(otherItemsSorted, function(item){
      otherItems[item.id] = item;
    });

    let i = 0;

    _.each(otherItems, function (item) {
        i++;

        let newPosition = i;

        if (newPosition >= position){
            newPosition = newPosition + 1;
        }

        item.position = newPosition;
    });

    otherItems[id] = items[id];
    otherItems[id].position = position;

    return otherItems;
}